import { render, staticRenderFns } from "./statTypeButton.vue?vue&type=template&id=5abea87a&scoped=true"
import script from "./statTypeButton.vue?vue&type=script&lang=js"
export * from "./statTypeButton.vue?vue&type=script&lang=js"
import style0 from "./statTypeButton.vue?vue&type=style&index=0&id=5abea87a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abea87a",
  null
  
)

export default component.exports